module.exports = __webpack_public_path__ + "static/media/beaconManageProducts.cdf797da.jpeg";